import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ambassador-contact")({
  component: lazyRouteComponent(() => import("./-pages/admin.ambassador-contact")),
  head: () => ({ meta: [{ title: "Contact LECMO Lovers — Lecmo Admin" }] }),
});
